module.exports = __webpack_public_path__ + "img/feature_a06.24074c74.svg";